import { useAccountCashflowsApi } from '../api';

export const useAccountCashflows = () => {
  const response = useAccountCashflowsApi({});
  return response;
};
